.infoText {
  color: var(--body-text-arrows-400);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-title + gz-form-field {
  margin-top: calc(var(--spacer) * 2);
}

#form-whitelisted-domains-table-component::part(header-buttons) {
  margin-top: 0;
}

#relay-domain-whitelist-subtitle {
  padding-bottom: calc(var(--spacer));
}

.form-field-info-text {
  padding-left: calc(var(--spacer) * 3.3);
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
}
